import SafeImage from '@ui/SafeImage';
import type { ProductDocument } from 'models/product';
import {
  SellerProductOrderLinks,
  useSellerProductOrders,
} from './SellerProductOrders';

const SoldOrDraftBlock = ({
  variant,
  product,
}: {
  variant: 'sold' | 'draft';
  product?: ProductDocument;
}) => {
  const { isSeller, orders } = useSellerProductOrders(
    variant === 'sold' ? product : undefined
  );
  const sellerSold = variant === 'sold' && isSeller;

  return (
    <div className="flex w-full flex-col gap-[1.6rem] rounded-3xl bg-brand-secondary p-[2.4rem]">
      <div className="flex w-full items-center gap-[2rem]">
        <SafeImage
          src="/sold-sign.svg"
          width={32}
          height={32}
          alt={'sold sign'}
        />
        <div className="flex w-full flex-col justify-center text-brand-white">
          <span className="text-[1.6rem] font-semibold">
            {variant === 'draft'
              ? 'Draft Listing'
              : sellerSold
              ? 'You sold this item!'
              : 'Item Sold!'}
          </span>
          <span className="text-[1.4rem]">
            This item has recently been purchased.
          </span>
        </div>
      </div>

      {sellerSold && orders.length > 0 && (
        <SellerProductOrderLinks orders={orders} tone="dark" />
      )}
    </div>
  );
};

export default SoldOrDraftBlock;
